<template>
  <div class="page-default overflow-hidden">
    <div class="dashboard-section bg-dashboard-dark-2 hide-print">
      <div class="cases-group">
        <div class="row h-100 position-relative">
          <div
            class="col-12 h-auto d-flex justify-content-between align-items-center pb-3 sticky-top bg-dashboard-dark-2"
            style="z-index: 2">
            <div class="flex-fill d-flex justify-content-start align-items-center">
              <div class="dropdown">
                <button id="dropdownMenuButton" type="button" class="btn btn-sm dropdown-toggle btn-dark shadow-sm px-3"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-placement="top"
                  @mouseover="helper.showTooltip" @mouseleave="helper.hideTooltip" title="Filter by Date">
                  <font-awesome-icon :icon="['far', 'calendar-alt']" class="mr-2" />
                  {{ computedDateFilter }}
                </button>
                <div id="dropdown-menu" class="dropdown-menu shadow px-2" @click.stop>
                  <v-date-picker is-dark class="inline-calendar border-0" v-model="dateFilter" :model-config="{
                    type: 'string',
                    mask: 'YYYY-MM-DD',
                  }" mode="date" is-range trim-weeks is-expanded />
                </div>
              </div>
              <div class="dropdown ml-3">
                <button id="dropdownDistrictButton" type="button"
                  class="btn btn-sm dropdown-toggle btn-dark shadow-sm px-3 no-pseudo" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false" data-placement="top" @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip" title="Filter by District">
                  <font-awesome-icon :icon="['fas', 'filter']" class="mr-2" />
                  {{ districtFilter ? districtFilter.name : "All Districts" }}
                </button>
                <div class="dropdown-menu shadow p-0" aria-labelledby="dropdownDistrictButton"
                  style="max-height: 55vh; overflow-y: auto">
                  <button
                    class="dropdown-item font-weight-medium d-flex justify-content-between align-items-center btn-secondary fs-8 px-3 py-2 border-outline-dark-bottom"
                    :class="districtFilter == null ? 'text-white' : 'text-light'
                      " @click="districtFilter = null">
                    All districts
                    <font-awesome-icon :icon="['fas', 'check']" class="text-primary ml-3 small"
                      v-if="districtFilter == null" />
                  </button>
                  <button v-for="district in allDistricts" :key="district._id"
                    class="dropdown-item d-flex justify-content-between align-items-center btn-secondary fs-8 px-3 py-2 border-outline-dark-bottom"
                    :class="districtFilter && districtFilter._id == district._id
                      ? 'text-white'
                      : 'text-light'
                      " @click="districtFilter = district">
                    {{ district.name }}
                    <font-awesome-icon :icon="['fas', 'check']" class="text-primary ml-3 small" v-if="
                      districtFilter && districtFilter._id == district._id
                    " />
                  </button>
                </div>
              </div>
              <div class="dropdown ml-3">
                <button id="dropdownDistrictButton" type="button"
                  class="btn btn-sm dropdown-toggle btn-dark shadow-sm px-3 no-pseudo" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false" data-placement="top" @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip" title="Filter by Source">
                  <font-awesome-icon :icon="['fas', 'filter']" class="mr-2" />
                  {{ sourceFilter ? sourceFilter : "Filter Source" }}
                </button>
                <div class="dropdown-menu shadow p-0" aria-labelledby="dropdownDistrictButton"
                  style="max-height: 55vh; overflow-y: auto">
                  <button
                    class="dropdown-item font-weight-medium d-flex justify-content-between align-items-center btn-secondary px-3 py-2 fs-8 border-outline-dark-bottom"
                    :class="sourceFilter == null ? 'text-white' : 'text-light'" @click="sourceFilter = null">
                    All Sources
                    <font-awesome-icon :icon="['fas', 'check']" class="text-primary ml-3 small"
                      v-if="sourceFilter == null" />
                  </button>
                  <button v-for="source in listOfSocialMediaType" :key="source"
                    class="dropdown-item d-flex justify-content-between align-items-center btn-secondary px-3 py-2 fs-8 border-outline-dark-bottom"
                    :class="sourceFilter == source ? 'text-white' : 'text-light'
                      " @click="sourceFilter = source">
                    {{ source }}
                    <font-awesome-icon :icon="['fas', 'check']" class="text-primary ml-3 small"
                      v-if="sourceFilter && sourceFilter == source" />
                  </button>
                </div>
              </div>
            </div>

            <div>
              <div class="dropdown ml-3">
                <button id="dropdownDistrictButton" type="button"
                  class="dropdown-toggle btn btn-sm btn-primary mr-2 no-pseudo" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false" data-placement="top" @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip" title="Download" :disabled="!computedListCases.length">
                  Download
                </button>
                <div class="dropdown-menu shadow p-0" aria-labelledby="dropdownDistrictButton"
                  style="max-height: 55vh; overflow-y: auto">
                  <button class="dropdown-item btn-secondary px-3 py-2 fs-8 border-outline-dark-bottom text-white"
                    @click="createPDF">
                    <font-awesome-icon :icon="['fas', 'file-download']" class="mr-2" />
                    PDF
                  </button>
                  <download-csv
                    class="dropdown-item btn-secondary px-3 py-2 fs-8 border-outline-dark-bottom text-white cursor-pointer btn-hightlight"
                    :data="complaintDataExport" :name="csvFileName">
                    <font-awesome-icon :icon="['fas', 'file-download']" class="mr-2" />
                    CSV</download-csv>
                </div>
              </div>
            </div>

            <button class="btn btn-sm btn-primary" @click="toggleComplaintModal(true)" data-toggle="tooltip"
              data-placement="top" @mouseover="helper.showTooltip" @mouseleave="helper.hideTooltip"
              title="Create new complaint">
              <font-awesome-icon :icon="['fas', 'plus']" class="mr-2" />
              New complaint
            </button>
          </div>

          <template v-if="isLoaded">
          <div class="col-12 h-auto">
            <div class="table-responsive table-sm w-auto small rounded border h-100 bg-dashboard-dark-1"
              style="max-width: 400px">
              <table class="table table-sm table-bordered rounded mb-0">
                <thead class="bg-primary text-white px-3 align-middle">
                  <tr>
                    <th colspan="3"
                      class="font-weight-normal text-white border bg-dashboard-dark-1 border-outline-dark-all">
                      Summary for {{ computedDateFilter }}
                    </th>
                  </tr>
                  <tr>
                    <th class="bg-primary border border-outline-dark-all">
                      Status
                    </th>
                    <th class="text-center bg-primary border border-outline-dark-all">
                      Count
                    </th>
                    <th class="text-center bg-primary border border-outline-dark-all">
                      %
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="px-3 text-white border border-outline-dark-all">
                      SOLVED<sup class="text-danger font-weight-bold">*</sup>
                    </td>
                    <td class="px-3 fit-content text-center text-white border border-outline-dark-all">
                      {{ solvedCasesCount }}
                    </td>
                    <td class="px-3 fit-content text-right text-white border border-outline-dark-all">
                      {{
                        (
                          (solvedCasesCount / (computedListCases.length || 1)) *
                          100
                        ).toFixed(2)
                      }}
                      %
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 text-white border border-outline-dark-all">
                      PENDING
                    </td>
                    <td class="px-3 fit-content text-center text-white border border-outline-dark-all">
                      {{ pendingCasesCount }}
                    </td>
                    <td class="px-3 fit-content text-right text-white border border-outline-dark-all">
                      {{
                        (
                          (pendingCasesCount / (computedListCases.length || 1)) *
                          100
                        ).toFixed(2)
                      }}
                      %
                    </td>
                  </tr>
                  <tr>
                    <td class="px-3 font-weight-medium text-white border border-outline-dark-all">
                      TOTAL
                    </td>
                    <td
                      class="px-3 fit-content text-center font-weight-medium text-white border border-outline-dark-all">
                      {{ computedListCases.length }}
                    </td>
                    <td
                      class="px-3 fit-content text-right font-weight-medium text-white border border-outline-dark-all">
                      {{ computedListCases.length ? '100.00 %' : '0.00 %' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <small class="text-muted">
              <sup class="text-danger font-weight-bold">*</sup>
              includes Not Related complaints
            </small>
          </div>

          <div class="col-12 h-auto">
            <div class="table-responsive table-sm small rounded border h-100 bg-dashboard-dark-1">
              <table class="table table-sm table-bordered rounded mb-0">
                <thead class="bg-primary text-white px-3 align-middle">
                  <tr>
                    <th class="text-center fit-content bg-primary border border-outline-dark-all text-white">
                      #
                    </th>
                    <th class="fit-content text-center p-1 bg-primary border border-outline-dark-all text-white">
                      Image
                    </th>
                    <th class="bg-primary border border-outline-dark-all text-white">
                      Complainant
                    </th>
                    <th class="bg-primary border border-outline-dark-all text-white">
                      Remarks
                    </th>
                    <th class="fit-content text-center bg-primary border border-outline-dark-all text-white">
                      Date &amp; Time
                    </th>
                    <th class="fit-content text-center bg-primary border border-outline-dark-all text-white">
                      Source of<br />Complaint
                    </th>
                    <th class="fit-content text-center bg-primary border border-outline-dark-all text-white">
                      Coordinate /<br />Location
                    </th>
                    <th class="bg-primary border border-outline-dark-all text-white">
                      Related Road
                    </th>
                    <th class="bg-primary border border-outline-dark-all text-white">
                      Status
                    </th>
                    <th class="bg-primary border border-outline-dark-all text-white">
                      Action By
                    </th>
                    <th class="text-center bg-primary border border-outline-dark-all text-white">
                      Related Case
                    </th>
                  </tr>
                </thead>
                <tbody class="px-3">
                  <tr v-if="isLoaded && computedListCases.length < 1">
                    <td colspan="11" class="text-center text-muted font-italic border-outline-dark-all">
                      No complaint found.
                    </td>
                  </tr>
                  <tr v-for="(_case, index) in computedListCases" :key="_case._id">
                    <td class="text-center fit-content font-weight-medium border border-outline-dark-all">
                      <p class="mb-0 text-white">{{ index + 1 }}</p>
                      <button class="btn btn-sm btn-block text-primary p-0" @click="toggleComplaintModal(true, _case)">
                        <font-awesome-icon :icon="['far', 'edit']" />
                      </button>
                      <button class="btn btn-sm btn-block text-danger p-0" @click="deleteComplaint(_case)">
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </td>
                    <td class="fit-content p-1 border border-outline-dark-all">
                      <div class="media justify-content-center">
                        <img class="media-image rounded shadow-sm clickable" style="object-fit: cover" :src="helper.formatMediaUrl(
                          _case.media[_case.media.length - 1]
                        )
                          " @click="
                            currentImage = _case.media[_case.media.length - 1]
                            " v-if="_case.media && _case.media.length > 0" />
                      </div>
                    </td>
                    <td v-html="[
                      _case.socmedUsername,
                      ['whatsapp', 'textMessage'].includes(_case.type)
                        ? _case.socmedPostUrl // untuk whatsapp/textMessage, guna field ni untuk phone number
                        : null,
                    ]
                      .filter((c) => c)
                      .join('<br />')
                      " class="text-wrap border border-outline-dark-all text-white" style="width: 200px"></td>
                    <td class="text-wrap border border-outline-dark-all" style="width: 200px">
                      <text-highlighter class="text-white" :type="_case.type" :text="_case.caption" />
                    </td>
                    <td class="fit-content text-nowrap border border-outline-dark-all text-white"
                      v-html="getMoment('table', _case.timestamp)"></td>
                    <td class="fit-content text-center text-capitalize border border-outline-dark-all text-white">
                      {{ helper.titleCase(_case.type) }}
                    </td>
                    <td class="fit-content text-center border border-outline-dark-all text-white" v-html="[
                      _case.lat && _case.lng
                        ? `<a target='_blank' href='http://www.google.com/maps/place/${_case.lat
                        },${_case.lng}'>${helper.formatCoordinate([
                          _case.lat,
                          _case.lng,
                        ])}</a>`
                        : null,
                      _case.generalLocation,
                    ]
                      .filter((c) => c)
                      .join('<br />')
                      "></td>
                    <td class="border border-outline-dark-all text-white">
                      {{
                        _case.road
                          ? `${_case.road.name}, ${getDistrictName(
                            _case.road.daerah
                          )}`
                          : ""
                      }}
                    </td>
                    <td class="border border-outline-dark-all text-white">
                      <div class="badge text-white badge-pill mb-2 align-middle" :class="translateStatus(_case) == 'Open'
                        ? 'badge-danger'
                        : 'badge-success'
                        ">
                        {{ translateStatus(_case) }}
                      </div>
                    </td>
                    <td class="border border-outline-dark-all text-white">
                      {{ _case.actionBy }}
                    </td>
                    <td class="text-center align-top border border-outline-dark-all">
                      <template v-if="_case.relatedCase">
                        <p class="mb-3 h6">
                          <span class="badge badge-secondary text-uppercase px-3 py-2" :class="{
                            'badge-success':
                              _case.relatedCase.status == 'solved',
                            'badge-info':
                              _case.relatedCase.status == 'inProgress',
                          }">
                            {{ caseStatusText(_case.relatedCase) }}
                          </span>
                        </p>
                        <div class="row mb-3" v-if="
                          _case.relatedCase.media_after &&
                          _case.relatedCase.media_after.length > 0
                        ">
                          <div class="col-6 media mx-auto p-0" v-for="media in _case.relatedCase.media_after"
                            :key="media._id">
                            <img class="media-image rounded shadow-sm clickable" style="object-fit: cover"
                              :src="helper.formatMediaUrl(media)" @click="currentImage = media" />
                          </div>
                        </div>
                        <router-link class="btn btn-sm btn-custom btn-block px-3" :to="{
                          name: 'cases',
                          params: {
                            id: _case.relatedCase.caseNumber,
                          },
                        }" target="_blank">
                          View case
                          <font-awesome-icon :icon="['fas', 'angle-right']" class="ml-2" />
                        </router-link>
                      </template>
                      <template v-else-if="_case.status == 'notRelated'">
                        <p class="h6">
                          <span class="badge badge-danger text-uppercase px-3 py-2">
                            Not Related
                          </span>
                        </p>
                      </template>
                      <template v-else>
                        <button class="btn btn-sm btn-danger btn-block mx-auto mb-3" @click="setAsNotRelated(_case)">
                          Set as Not Related
                          <font-awesome-icon :icon="['fas', 'minus-circle']" class="ml-2" />
                        </button>
                        <button class="btn btn-sm btn-primary btn-block mx-auto" @click="addToCase(_case)">
                          Add to case
                          <font-awesome-icon :icon="['fas', 'plus']" class="ml-2" />
                        </button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          </template>
        </div>
      </div>
    </div>
    <media-preview :downloadImage="true" v-if="currentImage" :url="helper.formatMediaUrl(currentImage)"
      @close="currentImage = null" />
    <edit-complaint-modal :show="showComplaintModal" :complaint="currentComplaint" :districts="allDistricts"
      @close="toggleComplaintModal" />
    <spinner v-if="isProcessing" />
  </div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";
import Moment from "moment";
import API from "@/api";
import Helper from "@/helper";
import Spinner from "@/components/Spinner";
import MediaPreview from "@/components/MediaPreview";
import EditComplaintModal from "@/modals/EditComplaint";
import TextHighlighter from "@/components/TextHighlighter";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "social",
  components: {
    MediaPreview,
    EditComplaintModal,
    Spinner,
    TextHighlighter,
  },
  data() {
    const date = new Date();
    return {
      csvFileName: `Complaints ${date.getDate()}-${date.getMonth() + 1
        }-${date.getFullYear()}.csv`,
      showComplaintModal: false,
      currentComplaint: null,
      helper: Helper,
      currentImage: null,
      isProcessing: false,
      isLoaded: false,
      allDistricts: [],
      cases: [],
      currentView: "card",
      dateFilter: {
        start: Moment().subtract(7, "days").startOf("day").format("YYYY-MM-DD"),
        end: Moment().endOf("day").format("YYYY-MM-DD"),
      },
      districtFilter: null,
      sourceFilter: null,
      listOfSocialMediaType: ["Facebook", "Twitter", "Whatsapp"],
      complaintDataExport: [],
    };
  },
  watch: {
    dateFilter() {
      $(".dropdown-toggle").dropdown("hide");

      this.getCases();
    },
    districtFilter() {
      this.getCases();
    },
  },
  computed: {
    pendingCasesCount() {
      return this.computedListCases.filter(
        (c) =>
          c.status != "notRelated" && c.status != "solved"
      ).length;
    },
    solvedCasesCount() {
      return this.computedListCases.filter(
        (c) =>
          c.status == "notRelated" || c.status == "solved"
      ).length;
    },
    computedDateFilter() {
      return `${Moment(this.dateFilter.start).format("YYYY-MM-DD")} to ${Moment(
        this.dateFilter.end
      ).format("YYYY-MM-DD")}`;
    },
    computedListCases() {
      let _cases = JSON.parse(JSON.stringify(this.cases));

      if (this.districtFilter) {
        _cases = _cases.filter(
          (_case) => _case.road && _case.road.daerah == this.districtFilter._id
        );
      }
      if (this.sourceFilter) {
        _cases = _cases.filter(
          (_case) => _case.type == this.sourceFilter.toLowerCase()
        );
      }

      this.complaintDataExport = _cases.map((item, index) => {
        const dateTime = this.getMoment("table", item.timestamp).split(
          "<br />"
        );
        return {
          No: index + 1,
          Image: item.media && item.media.length > 0 ? item.media[0].url : "",
          Complainant: item.socmedUsername,
          Remarks: item.caption,
          Date_Time: dateTime[0] + " " + dateTime[1],
          Source_of_Complaint:
            item.type[0].toUpperCase() + item.type.substring(1, 200),
          Coordinate_Location: "",
          Related_Road: !item.road
            ? ""
            : item.road.name + "," + item.subdistrict,
          Action_By: item.actionBy,
        };
      });

      return _cases;
    },
    getDistrictName() {
      return (districtId) => {
        if (!districtId) {
          return null;
        } else {
          const district = this.allDistricts.find(
            (district) => district._id == districtId
          );

          return district ? district.name : null;
        }
      };
    },
  },
  methods: {
    translateStatus(c) {
      if (c.status == 'notRelated' || c.status == "solved") {
        return "Closed";
      } else {
        return "Open";
      }
    },
    createPDF() {
      const date = new Date();
      let pdfName = `Complaints ${date.getDate()}-${date.getMonth() + 1
        }-${date.getFullYear()}`;
      var doc = new jsPDF();

      doc.autoTable({
        startY: 15,
        showHead: "firstPage",
        fontSize: 8,
        headStyles: {
          fillColor: [58, 88, 152],
        },
        bodyStyles: { valign: "top" },
        styles: { overflow: "linebreak", columnWidth: "auto" },
        columnStyles: {
          0: { cellWidth: 8 },
          1: { cellWidth: 18 },
          2: { cellWidth: 22 },
          3: { cellWidth: "auto" },
          4: { cellWidth: 20 },
          5: { cellWidth: 20 },
          6: { cellWidth: "auto" },
          7: { cellWidth: "auto" },
          8: { cellWidth: 15 },
        },
        theme: "grid",
        didDrawCell: function (data) {
          if (data.column.index === 1 && data.cell.section === "body") {
            doc.addImage(
              data.cell.raw,
              "JPEG",
              data.cell.x + 2,
              data.cell.y + 2,
              15,
              15
            );
          }
        },
        didParseCell: function (data) {
          if (data.cell.section === "body") {
            data.row.height = 35;
          }
          if (data.column.index === 1 && data.cell.section === "body") {
            data.cell.text = "";
            // data.cell.styles.fillColor = [255, 255, 255];
          }
        },
        head: [
          [
            "No",
            "Image",
            "Complainant",
            "Remarks",
            "Date & Time",
            "Source of\nComplaint",
            "Coordinate Location",
            "Related Road",
            "Action By",
          ],
        ],
        body: this.complaintDataExport.map((x) => {
          return [
            x.No,
            x.Image,
            x.Complainant,
            x.Remarks,
            x.Date_Time,
            x.Source_of_Complaint,
            x.Coordinate_Location,
            x.Related_Road,
            x.Action_By,
          ];
        }),
      });
      doc.save(pdfName + ".pdf");
    },
    deleteComplaint(_case) {
      Swal.fire({
        title: "Delete this complaint?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
        confirmButtonColor: "red",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.isProcessing = true;

            await API.delete(`cases/${_case._id}`);

            this.cases = this.cases.filter((cse) => cse._id != _case._id);

            Swal.fire("Complaint deleted", "", "success");
          } catch (error) {
            Swal.fire("Error", JSON.stringify(error.message), "error");
          } finally {
            this.isProcessing = false;
          }
        }
      });
    },
    caseStatusText(_case) {
      if (_case) {
        return _case.status == "inProgress" ? "in progress" : _case.status;
      } else {
        return "";
      }
    },
    setAsNotRelated(_case) {
      Swal.fire({
        title: "Set as not related?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.isProcessing = true;

            await API.put(`cases/${_case._id}`, {
              status: "notRelated",
            });

            _case.status = "notRelated";

            Swal.fire(
              "<div class='d-flex align-items-center'>Complaint set as <pre class='mb-0 ml-2 p-2 bg-light rounded border'>Not Related</pre></div>",
              "",
              "success"
            );
          } catch (error) {
            Swal.fire("Error", JSON.stringify(error.message), "error");
          } finally {
            this.isProcessing = false;
          }
        }
      });
    },
    addToCase(_case) {
      Swal.fire({
        title: "Add this complaint to case?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.isProcessing = true;

            let body = JSON.parse(JSON.stringify(_case));

            body.source = "mobileApp";
            body.type = "mobile";
            body.status = "received";
            body.relatedCase = _case._id;
            body.media = body.media ? body.media.map((media) => media._id) : [];
            body.media_during = body.media_during
              ? body.media_during.map((media) => media._id)
              : [];
            body.media_after = body.media_after
              ? body.media_after.map((media) => media._id)
              : [];

            delete body.id;
            delete body._id;
            delete body.caseNumber;

            const { data } = await API.post("cases", body);

            await API.put(`cases/${_case._id}`, {
              relatedCase: data._id,
            });

            await this.getCases();

            Swal.fire("Complaint added to case", "", "success");
          } catch (error) {
            Swal.fire("Error", JSON.stringify(error.message), "error");
          } finally {
            this.isProcessing = false;
          }
        }
      });
    },
    toggleComplaintModal(show, data) {
      this.showComplaintModal = show;

      if (show) {
        this.currentComplaint = data;
      } else {
        if (data) {
          this.getCases();
        }
      }
    },
    getMoment(type, d) {
      if (!d) {
        return "-";
      } else {
        switch (type) {
          case "title":
            return Moment(d).format("DD MMMM YYYY, hh:mm A");
          case "display":
            return Moment(d).fromNow(false);
          case "table":
            return Moment(d).format("DD MMMM YYYY<br />hh:mm A");
          default:
            return "";
        }
      }
    },
    async getCases() {
      this.isProcessing = true;
      this.isLoaded = false;

      let url =
        "cases?timestamp_null=false&_sort=timestamp:DESC&_limit=-1&source=socialMedia&type_nin=waze&type_nin=instagram";

      if (this.dateFilter.start && this.dateFilter.end) {
        url += `&timestamp_gte=${Moment(this.dateFilter.start)
          .startOf("day")
          .toISOString()}&timestamp_lte=${Moment(this.dateFilter.end)
            .endOf("day")
            .toISOString()}`;
      }

      API.get(url)
        .then((retVal) => {
          this.cases = retVal.data;
          this.isProcessing = false;
          this.isLoaded = true;
        })
        .catch((err) => {
          console.error(err);
          this.isProcessing = false;
          this.isLoaded = true;
        });
    },
    async getDistricts() {
      this.isProcessing = true;

      let url = "districts?_sort=name";

      return API.get(url)
        .then((retVal) => {
          this.allDistricts = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
  },
  async mounted() {
    await this.getCases();
    await this.getDistricts();
  },
};
</script>
<style lang="scss">
@import "@/assets/css/print.scss";
</style>